// Feature flags — set PAYMENTS_ENABLED or PRICING_ENABLED to true to restore those flows
export const FEATURES = {
  PAYMENTS_ENABLED: false,
  PRICING_ENABLED: false,
  ADS_ENABLED: true,
  // Ad frequency: show one banner every N job cards in the list feed
  AD_FREQUENCY: 4,
};
